import { render, staticRenderFns } from "./OnRequestButton.vue?vue&type=template&id=6708c9de&"
import script from "./OnRequestButton.vue?vue&type=script&lang=js&"
export * from "./OnRequestButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports